<div class="process-step-link-outer-container"
     [ngClass]="processStepLinkClass$ | async">
    <div class="process-step-link-container">
        <adapt-link-process-step [processStep]="processStep$ | async"
                                 [alignTextToRightOfIcon]="true"
                                 (stepClick)="stepClick.emit($event)"></adapt-link-process-step>
        <div class="link-container-padding"></div>
        @if (isEditing) {
            @if ((isLink$ | async) === false) {
                <adapt-menu [items]="editMenu"></adapt-menu>
            } @else {
                <button adaptButton="deleteBorderless"
                        adaptTooltip="Delete process step"
                        (click)="delete()"></button>
            }
        }
    </div>

    @if (processStep$ | async; as processStep) {
        @if (processStep!.extensions.isRoleTask && (isEditing || processStep!.role)) {
            <adapt-link-role [role]="processStep!.role"
                             [showIcon]="true"></adapt-link-role>
        }
    }
</div>
